import { render, staticRenderFns } from "./mbtiList.vue?vue&type=template&id=07c2739e&scoped=true&"
import script from "./mbtiList.vue?vue&type=script&lang=js&"
export * from "./mbtiList.vue?vue&type=script&lang=js&"
import style0 from "./mbtiList.vue?vue&type=style&index=0&id=07c2739e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2739e",
  null
  
)

export default component.exports